import React from 'react';

function GenesisRouting({ genesis }) {
  if (!genesis) return null;

  const cells = genesis.active_cells || [];
  const strengths = genesis.activation_strength || {};
  const pathway = genesis.knowledge_pathway || '';

  return (
    <div className="genesis-routing">
      {/* Knowledge Pathway */}
      <div className="genesis-pathway">
        <div className="genesis-pathway-label">Knowledge Pathway</div>
        <div className="genesis-pathway-flow">
          {pathway.split(' -> ').map((step, i, arr) => (
            <span key={i} className="genesis-pathway-step">
              <span className="genesis-step-text">{step}</span>
              {i < arr.length - 1 && <span className="genesis-step-arrow">{'\u2192'}</span>}
            </span>
          ))}
        </div>
      </div>

      {/* Active Genesis Cells */}
      <div className="genesis-cells">
        <div className="genesis-cells-label">Active Genesis Cells ({cells.length})</div>
        <div className="genesis-cells-grid">
          {cells.map((cell) => {
            const strength = strengths[cell] || 0.5;
            const pct = Math.round(strength * 100);
            return (
              <div key={cell} className="genesis-cell">
                <div className="genesis-cell-name">{cell.replace(/_/g, ' ')}</div>
                <div className="genesis-cell-bar-bg">
                  <div
                    className="genesis-cell-bar"
                    style={{ width: `${pct}%` }}
                  />
                </div>
                <div className="genesis-cell-strength">{pct}%</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default GenesisRouting;
